import type { Product, ProductSku } from "./types";

export function displaySku(product: Product): ProductSku | null {
  return product.skus.find((sku) => sku.available > 0) ?? product.skus[0] ?? null;
}

export function schemaAvailability(
  availability: "InStock" | "OutOfStock" | undefined,
  available?: number,
): "https://schema.org/InStock" | "https://schema.org/OutOfStock" {
  const inStock =
    typeof available === "number" ? available > 0 : availability === "InStock";
  return inStock
    ? "https://schema.org/InStock"
    : "https://schema.org/OutOfStock";
}
